import React from 'react';

export default function SourcesSection({ sources }) {
  if (!sources || sources.length === 0) return null;

  return (
    <section id="kilder" className="mt-12 pt-8 border-t border-[#DCE3EC] text-sm text-[#5C6670]">
      <div className="font-semibold text-[#141B22] mb-3">Kilder:</div>
      <ul className="space-y-2">
        {sources.map((src, idx) => (
          <li key={idx} className="flex items-start gap-2">
            <span className="text-[#2A4DB0] font-mono text-xs mt-1">[{idx + 1}]</span>
            <a
              href={src.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#2A4DB0] hover:underline"
            >
              {src.title}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
